import {DayByDayClientFields} from "../interfaces/DayByDayClientInterfaces";

export const DAY_BY_DAY_CLIENT_INITIAL_VALUES : DayByDayClientFields  = {
  customerTourName: "",
  paxClientNumber: 0,
  managerContacts: [],
}
